<script>
  import { onMount } from 'svelte';
  import { KEYCODES } from './constants.ts';
  
  let { container = null, onEscapeHandler = () => {} } = $props();

  onMount(() => {
    const element = container || window;
    const keydownHandler = (event) => {
      if (event.keyCode === KEYCODES.ESCAPE) {
        onEscapeHandler();
      }
    };
    element.addEventListener('keydown', keydownHandler);

    return () => {
      element.removeEventListener('keydown', keydownHandler);
    };
  });
</script>
